import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";

const pwToken = process.env.REACT_APP_SECRET_PW;

function SecretPwCheck() {
  const location = useLocation();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const handleChange = (e) => {
    setPassword(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === pwToken) {
      sessionStorage.setItem("secretAuthed", "true");
      navigate(location.state?.from || "/", { replace: true });
    } else {
      setPassword("");
      setError("비밀번호가 틀렸습니다.");
    }
  };

  return (
    <div className="secret-pw-check">
      <h1>비밀번호 입력</h1>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="비밀번호를 입력하세요"
          value={password}
          onChange={(event) => {
            handleChange(event);
            setError("");
          }}
        />
        <button type="submit">확인</button>
      </form>
      <span className="errorMsg">{error}</span>
    </div>
  );
}

export default SecretPwCheck;
